import type React from 'react';

import { localStorageColorSchemeManager, MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { AppearanceSync } from '@/components/AppearanceSync';
import { appCssVariablesResolver } from './cssVariablesResolver';
import { COLOR_SCHEME_STORAGE_KEY, DEFAULT_COLOR_SCHEME, theme } from './mantineTheme';

const colorSchemeManager = localStorageColorSchemeManager({ key: COLOR_SCHEME_STORAGE_KEY });

export default function Theme({ children }: { children: React.ReactNode }) {
	return (
		<MantineProvider
			theme={theme}
			cssVariablesResolver={appCssVariablesResolver}
			colorSchemeManager={colorSchemeManager}
			defaultColorScheme={DEFAULT_COLOR_SCHEME}
		>
			<Notifications position="bottom-center" pauseResetOnHover="notification" />
			<AppearanceSync />
			{children}
		</MantineProvider>
	);
}
